import * as React from "react";
import type { SVGProps } from "react";
const SvgVolotea = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 50 50"
    width="100%"
    height="100%"
    {...props}
  >
    <g fill="#ed164a">
      <path d="m17.333 40.337 7.67-7.673 7.664 7.673L25.002 48zM17.333 9.668 25.003 2l7.664 7.668-7.665 7.668zM32.666 25l7.67-7.665L48 25l-7.665 7.666zM2 25l7.67-7.665L17.333 25l-7.665 7.666z" />
      <path d="M11.37 34.37v-3.407l-1.7 1.702zm1.706 1.704 1.706 1.703v-10.22l-1.706 1.705zm3.409-10.218v13.63l.85.851.848-.852v-13.63L17.334 25zm6.808 5.107v3.407l1.71-1.705zm-3.404 6.814 1.706-1.703v-6.812l-1.706-1.705zM26.703 19.034v-3.402l-1.705 1.705zm1.703 1.705 1.706 1.704V12.22l-1.706 1.708zm3.407-10.218V24.15l.854.851.85-.851V10.52l-.85-.854zm6.813 5.11v3.403l1.705-1.697zm-3.406 6.812 1.707-1.704v-6.811L35.22 12.22z" />
      <path d="M26.703 34.37v-3.407l-1.705 1.702zm1.703 1.704 1.706 1.703v-10.22l-1.706 1.705zm3.407-10.218v13.63l.854.851.85-.852v-13.63l-.85-.856zm6.813 5.107v3.407l1.705-1.705zm-3.406 6.814 1.707-1.703v-6.812l-1.708-1.705zM11.37 19.034v-3.402l-1.7 1.705zm1.706 1.705 1.706 1.704V12.22l-1.706 1.708zm3.409-10.218V24.15l.85.851.848-.851V10.52l-.849-.854zm6.808 5.11v3.403l1.71-1.697zm-3.404 6.812 1.706-1.704v-6.811l-1.706-1.708z" />
    </g>
  </svg>
);
export default SvgVolotea;
